import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, SproutIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="eco-grid relative isolate overflow-hidden bg-white" data-id="element-103" data-mp="sai3j1dgur5q">
      <div className="h-1.5 w-full bg-leaf" aria-hidden="true" data-id="element-104" data-mp="ncgk2fc4optq" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-105" data-mp="neawt6d8xbmq">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full bg-leafSoft px-4 py-2 text-xs font-extrabold uppercase tracking-[.14em] text-leafDark" data-id="element-106" data-mp="3d2tod9lewkej">
          <SproutIcon className="h-4 w-4" aria-hidden="true" data-id="element-107" data-mp="39acwgl67hgrf" /> Environmental Management Teacher Ready
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.05] text-navy sm:text-5xl lg:text-6xl" data-id="element-108" data-mp="3e8wielksusjs">
          Master your year of environmental education
          <br data-id="element-109" data-mp="2viy43nqes37p" />
          <span className="text-leaf" data-id="element-110" data-mp="2vietyt702j48">in one afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-111" data-mp="2hj5clq725iyo">
          <img src={productImage} alt="Environmental Management Teacher Ready: nine volumes and five bonus resources covering fundamentals, ecosystems, pollution prevention, impact assessment, waste and circular economy, management systems, climate change, sustainable development and teaching" className="mx-auto w-full drop-shadow-[0_24px_44px_rgba(11,42,74,.18)]" data-id="element-112" data-mp="s2tdhljfo9pq" />
        </motion.div>

        <div className="mt-9" data-id="element-113" data-mp="1ayjiziqkro8d">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-114" data-mp="161b01fxlrg62">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-navy" data-id="element-115" data-mp="110wr7vo6g26z">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-line bg-mist px-3 py-2" data-id="element-116" data-mp="3lt75ys5mbtus">
              <Icon className="h-3.5 w-3.5 text-leaf" aria-hidden="true" data-id="element-117" data-mp="3htpyxuajmoni" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-muted" data-id="element-118" data-mp="21a4txwhwuk6i">
          Created by environmental education specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}